<template>
    <div class="row">
        <div class="col-md-4">
            <div class="card first">
                <div class="card-body text-center">
                    <h1 class="title">
                        <div v-if="loading" class="spinner-grow fs-6"></div>
                        <template v-else>{{ en_to_bn(counts.user_count) }}</template>
                    </h1>
                    <p class="description">{{ __('Total Members') }}</p>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="card second">
                <div class="card-body text-center">
                    <h1 class="title">
                        <div v-if="loading" class="spinner-grow fs-6"></div>
                        <template v-else>{{ en_to_bn(counts.content_count) }}</template>
                    </h1>
                    <p class="description">{{ __('Total Contents') }}</p>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="card third">
                <div class="card-body text-center">
                    <h1 class="title">
                        <div v-if="loading" class="spinner-grow fs-6"></div>
                        <template v-else>{{ en_to_bn(counts.ambassador_count) }}</template>
                    </h1>
                    <p class="description">{{ __('Total Ambassadors') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            counts: {
                ambassador_count: 0,
                content_count: 0,
                user_count: 0,
            },
            loading: false,
        }
    },

    mounted() {
        this.observe_visibility(this.$el, () => this.fetchCounts());
    },

    methods: {
        async fetchCounts() {
            this.loading = true;
            await axios.get('/dashboard/counts')
                .then(({ data }) => this.counts = data.counts)
                .catch(console.error);

            this.loading = false;
        }
    },
}
</script>